import { ICustomerType } from '../../constants/customer';
import { ICustomer } from '../../interface/customer';

interface PrincipalCustomerFields {
  principalCompanyId: string | null;
  principalCompany: ICustomer | null;
  principalPrivatePersonId: string | null;
  principalPrivatePerson: (ICustomer & { fullName: string }) | null;
}

const principalFieldsByCustomerType: Record<
  ICustomerType,
  (customer: ICustomer) => PrincipalCustomerFields
> = {
  [ICustomerType.COMPANY]: (customer) => ({
    principalCompanyId: customer.id,
    principalCompany: customer,
    principalPrivatePersonId: null,
    principalPrivatePerson: null,
  }),
  [ICustomerType.PRIVATE_PERSON]: (customer) => ({
    principalPrivatePersonId: customer.id,
    principalPrivatePerson: { ...customer, fullName: customer.name },
    principalCompanyId: null,
    principalCompany: null,
  }),
};

export const buildPrincipalCustomerFields = (
  customer: ICustomer,
): PrincipalCustomerFields | undefined => principalFieldsByCustomerType[customer.type]?.(customer);
